<template>
  <div>
    <v-data-table
      :headers="columns"
      fixed-header
      :items="specifications"
      :hide-default-footer="
        specifications.length > 10 ? hideDefaultFooter : true
      "
      :items-per-page="specifications.length"
      :loading="loading"
      no-data-text="Дані відсутні"
      disable-sort
      height="auto"
      loading-text="Завантаження данних"
      :page.sync="page"
      @page-count="pageCount = $event"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td
            v-for="(column, i) in columns"
            :key="`column-${i}`"
            :style="column.style"
          >
            <a
              v-if="column.value === 'id'"
              :href="`${column.resource}/${item.specificationId}`"
              @click.prevent="
                $router.push({
                  path: `${column.resource}/${item.specificationId}`,
                })
              "
              >{{ item.specificationId }}</a
            >
            <span
              v-else-if="column.isColoredChip"
              style="display: block; text-align: center"
              class="v-chip__parent"
            >
              <v-chip
                :color="setEstimateCellColor(item, column.value)"
                outlined
              >
                <template v-if="column.type === 'dateHours'">
                  {{ item[column.value] | secondsToHours }}
                </template>
                <template v-else>
                  {{ item[column.value] }}
                </template>
              </v-chip>
            </span>
            <span
              v-else-if="column.type === 'circularProgress'"
              :style="{ display: 'block', textAlign: column.align }"
            >
              <v-progress-circular
                :value="item[column.value]"
                :color="
                  item[column.value] === 0
                    ? 'grey'
                    : item[column.value] > 100
                    ? 'red'
                    : item.color
                "
                size="45"
                >{{ `${item[column.value]}%` }}</v-progress-circular
              >
            </span>
            <span
              v-else-if="column.type === 'date' && item[column.value]"
              v-text="$options.filters.date(item[column.name])"
            />
            <span
              v-else-if="column.type === 'object' && item[column.value]"
              v-text="item[column.value].title"
            />
            <span v-else v-text="item[column.value]" />
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-pagination
      v-if="specifications.length"
      v-model="page"
      :length="pageCount"
    />
  </div>
</template>
<script>
import SimpleTable from "@/components/story/SimpleTable";
import { getClientSpecifications } from "../../../backend/specificationsApi.js";
export default {
  components: {
    SimpleTable,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    columns: [
      {
        text: "id",
        value: "id",
        width: 45,
        resource: "clientSpecifications",
      },
      {
        text: "Дата",
        value: "createdAt",
        type: "date",
        width: 50,
      },
      {
        text: "Автор",
        value: "author",
        width: 225,
        type: "object",
      },
      {
        text: "Найменування специфікації",
        value: "title",
        rowType: "wide",
        width: 212,
      },
      { text: "t (avg)", value: "tAvg", width: 100 },
      {
        text: "min",
        value: "estimateMin",
        rowType: "wide",
        align: "center",
        isColoredChip: true,
        isDesc: null,
      },
      {
        text: "norm",
        value: "estimateAvg",
        rowType: "wide",
        align: "center",
        isColoredChip: true,
      },
      {
        text: "max",
        value: "estimateMax",
        rowType: "wide",
        align: "center",
        isColoredChip: true,
      },
      {
        text: "Факт",
        value: "totalTimeSpentSeconds",
        align: "center",
        type: "dateHours",
      },
      {
        text: "Факт з грейдами",
        value: "factWithGrades",
        align: "center",
        isColoredChip: true,
      },
      {
        text: "Прогрес розробки",
        tooltip: "Факт з грейдами поділено на t (avg)",
        value: "devProgress",
        type: "circularProgress",
        width: 160,
        align: "center",
      },
    ],
    specifications: [],
    loading: false,
  }),
  async created() {
    this.loading = true;
    this.specifications = await getClientSpecifications();
    this.loading = false;
  },
  methods: {
    setEstimateCellColor(item, estimateName) {
      switch (true) {
        case estimateName === "estimateMin" &&
          item.factWithGrades <= item.estimateMin:
          item.factWithGradesColor = "green";
          item.color = "green";
          return "green";
        case estimateName === "estimateNorm" &&
          item.factWithGrades > item.estimateMin &&
          item.factWithGrades <= item.estimateNorm:
          item.factWithGradesColor = "yellow darken-2";
          item.color = "yellow darken-2";
          return "yellow darken-2";
        case estimateName === "estimateMax" &&
          item.factWithGrades > item.estimateNorm:
          item.factWithGradesColor = "red";
          item.color = "red";
          return "red";
        case estimateName === "factWithGrades":
          return item.factWithGradesColor;
        default:
          return "default";
      }
    },
  },
};
</script>
